import React from "react";

const btnBase = {
  border: "0",
  cursor: "pointer",
  borderRadius: "999px",
  padding: "10px 14px",
  fontWeight: 700,
  background: "#1f3b5191",
  color: "white",
  backdropFilter: "blur(6px)",
  WebkitBackdropFilter: "blur(6px)",
};

const iconBtn = {
  ...btnBase,
  width: "44px",
  height: "44px",
  display: "grid",
  placeItems: "center",
  padding: 0,
};

const VideoControls = ({
  isPlaying,
  isMuted,
  isVisible,
  requiresUserRestartForSound,
  onPrev,
  onNext,
  onPlayPause,
  onToggleMute,
}) => {
  const centerLabel = requiresUserRestartForSound
    ? "PLAY"
    : isPlaying
    ? "PAUSE"
    : "PLAY";

  return (
    <>
      {/* כפתור השתקה: למעלה בפנים בפינה */}
      <button
        type="button"
        onClick={onToggleMute}
        aria-label={isMuted ? "Unmute" : "Mute"}
        style={{
          ...iconBtn,
          position: "absolute",
          top: "10px",
          left: "10px",
          zIndex: 5,
        }}
      >
        {isMuted ? "🔇" : "🔊"}
      </button>

      {/* שורת הכפתורים בתחתית מרכז */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          bottom: "12px",
          transform: "translateX(-50%)",
          display: "flex",
          alignItems: "center",
          gap: "10px",
          zIndex: 5,
          padding: "8px 10px",
          borderRadius: "999px",
          background: "rgba(0, 0, 0, 0.25)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
        }}
      >
        <button type="button" onClick={onPrev} style={iconBtn} aria-label="Prev">
          ◀
        </button>

        <button
          type="button"
          onClick={onPlayPause}
          style={{ ...btnBase, minWidth: "110px" }}
          aria-label={centerLabel}
        >
          {centerLabel}
        </button>

        <button type="button" onClick={onNext} style={iconBtn} aria-label="Next">
          ▶
        </button>
      </div>
    </>
  );
};

export default VideoControls;
